import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoVideo from 'eco-design/base/eco-video';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct.SectionA4');

    return (
        <>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.comp}`}>
                <EcoVideo pc={'https://www.ecoflow.com/responsive/video/delta-pro-ultra/launch/7.mp4'} autoPlay={true} loop={true} />
            </div>
        </>
    );
}
